export default "__VITE_ASSET__3507e8e1__"